import { Injectable } from '@angular/core';

import { Observable, of, forkJoin, map } from 'rxjs';
import { EnrollmentService } from 'src/app/core/services/enrollment.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';
import { ReportsService } from 'src/app/core/services/reports.service';
import { ManagementUser } from 'src/app/core/models/management-user.model';
import { SchoolAdminTeacherFilterService } from 'src/app/shared/components/school-admin-teacher-filter/school-admin-teacher-filter.service';

interface EnrollmentResolverData {
  remainingDiagnosticLicenesesCount: number;
  remainingInterventionLicensesCount: number;
  gradeOptions: Object;
  genderOptions: Object;
  curriculumOptions: Object;
  assessmentTypeOptions: Object;
  teachers: ManagementUser[];
}

@Injectable({
  providedIn: 'root'
})

export class EnrollmentResolver  {
  constructor(
    private enrollmentService: EnrollmentService,
    private sessionStorageService: SessionStorageService,
    private teacherFilterService: SchoolAdminTeacherFilterService,
    private reportsService: ReportsService,
  ) {}

  resolve(): Observable<EnrollmentResolverData> {
    const currentUser = this.sessionStorageService.userData();
    let remainingDiagnosticLicenesesCount = this.enrollmentService.getRemainingDiagnosticLicensesCount(null, null);
    let remainingInterventionLicensesCount = this.enrollmentService.getRemainingInterventionLicensesCount(null, null);
    let gradeOptions = this.enrollmentService.getGradeOptions();
    let genderOptions = this.enrollmentService.getGenderOptions();
    // NOTE: default to setting secondary curriculum
    let curriculumOptions = this.enrollmentService.getCurriculumOptions(7);
    let assessmentTypeOptions = this.enrollmentService.getAssessmentTypeOptions();
    let teachers = currentUser
      ? this.reportsService.getAllActiveTeachers(currentUser, currentUser.schoolID)
      : of([]);

    // TODO: add .pipe to catchErr here
    let EnrollmentResolveData$ = forkJoin({
      remainingDiagnosticLicenesesCount,
      remainingInterventionLicensesCount,
      gradeOptions,
      genderOptions,
      curriculumOptions,
      assessmentTypeOptions,
      teachers: teachers.pipe(map((teachers) => {
        return this.teacherFilterService.sortTeachers(teachers);
      })),
    });
    return EnrollmentResolveData$;
  }

}
